<template>
  <div class="promotion-dialog" v-if="isShowPromotion">
    <div class="dialog-content" style="max-width: 1000px; width: 95vw; margin-top: 40px;">
      <div class="dialog-close" style="position: absolute; right: 10px; top: -36px;">
        <span @click="skip24Hours">Skip in 24hours</span>
        <span @click="closePromotion">Close <i class="el-icon-circle-close"></i></span>
      </div>
      <div class="dialog-inner" style="cursor: pointer;" @click="goToConvert">
        <img src="/assets/images/annoucements/announcement-convert-jun-20.jpg" alt="Promotion">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isShowPromotion: false,
      redirectRouter: 'Home'
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    jwt () {
      return this.$store.getters.jwt
    }
  },
  watch: {
    jwt (n, o) {
      if (n) {
        const redirectRouter = localStorage.getItem('rrgRedirectRouter')
        if (redirectRouter) {
          setTimeout(() => {
            this.$router.push({ name: redirectRouter })
            localStorage.removeItem('rrgRedirectRouter')
          }, 100)
        }
      }
    }
  },
  created () {
    const routeName = 'OrganizationFullChart'
    localStorage.removeItem('RRG_PROMOTION_SKIP_MAR_15')
    const skipTime = localStorage.getItem('RRG_PROMOTION_SKIP_JUN_15')
    const timeValid = skipTime && skipTime > new Date().getTime()
    if (timeValid || this.$route.name === routeName) {
      this.isShowPromotion = false
    } else {
      this.isShowPromotion = false
    }
    // Remove Redirect Router
    localStorage.removeItem('rrgRedirectRouter')
  },
  methods: {
    closePromotion () {
      this.isShowPromotion = false
    },
    skip24Hours () {
      const currentTime = new Date().getTime() + 86400000
      localStorage.setItem('RRG_PROMOTION_SKIP_JUN_15', currentTime)
      this.closePromotion()
    },
    goToConvert (e) {
      if (this.jwt) {
        this.$router.push({ name: this.redirectRouter })
      } else {
        const $loginBtn = document.getElementById('btn-login')
        $loginBtn.click()
        localStorage.setItem('rrgRedirectRouter', this.redirectRouter)
      }
      this.closePromotion()
    }
  }
}
</script>
